import { render, staticRenderFns } from "./companyReportTabReservedMeals.vue?vue&type=template&id=c4652410"
import script from "./companyReportTabReservedMeals.vue?vue&type=script&lang=js"
export * from "./companyReportTabReservedMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports